module.exports = __webpack_public_path__ + "static/media/ic-arrow-right-green.f52cee56.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-arrow-right-green.svg
// module id = 594
// module chunks = 14